import { Component, OnInit } from '@angular/core';
import { ROUTESPATH } from '@core';
import { TokenService, SectionTitleService, ModalService } from '@services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  newTitle = '';
  sectionTitleSubscription = null;
  public modalContactForm: boolean = false;
  public hovered: boolean = false;
  public focused: boolean = false;
  routes = ROUTESPATH;

  constructor(private sectionTitleService: SectionTitleService, private modalService: ModalService) {}

  ngOnInit(): void {
    this.sectionTitleSubscription = this.sectionTitleService.newTitle.subscribe(
      (title) => (this.newTitle = title)
      );
  }

  openModal(): void {
    this.modalService.openModalContactForm();
  }

  public get isLogged() {
    return TokenService.isLogged();
  }

  ngOnDestroy() {
    this.sectionTitleSubscription.unsubscribe();
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  
}
